module.exports = "/_next/static/images/48497a6a9831a7ddf5aa23d3a2c7424f-rewards-illustration@2x.png";